// eslint-disable-next-line import/no-unresolved
module.exports = require('./lib/constants');



//////////////////
// WEBPACK FOOTER
// ./~/react-dates/constants.js
// module id = QoJ3
// module chunks = 0